export default function TransactionTabs({
  tabs,
  activeTab,
  setActiveTab,
  setPage,
}) {
  return (
    <div className="flex flex-wrap gap-2">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => {
            setActiveTab(tab.key);
            setPage(1);
          }}
          className={`px-4 py-2 rounded-lg ${
            activeTab === tab.key
              ? "bg-purple-600 text-white"
              : "bg-white border"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}